import { PrimitiveField } from '../fields/createPrimitiveField';
import { FieldValidator } from '../fields/validation';
import { ValidationError } from '../types';

const EMAIL_REGEXP = new RegExp(
    // Regexp должен содержать кириллические символы не обернутые в i18n
    // eslint-disable-next-line @adv-frontend/config/no-rus-string-locales-rule -- см. выше
    '^\\s*[a-z0-9_\\.\\-\\+]+\\@(?:(?:[_a-zа-яёЄІЇєіїҐґ0-9][_a-zа-яёЄІЇєіїҐґ0-9-]*)\\.)+([a-z0-9а-яёЄІЇєіїҐґ]{2,15}|xn--[a-z0-9-]+)\\s*$',
    'i'
);

/**
 * Создает валидатор, проверяющий правильность написания email
 * @param code код ошибки
 * @returns валидатор
 */
export function emailValidator<
    Code extends string,
    FieldValue extends string,
    FieldContextInput,
    FieldContext,
    FieldActions,
    FieldSelectors,
>(
    code: Code
): FieldValidator<
    PrimitiveField<FieldValue, ValidationError<Code>, FieldContextInput, FieldContext, FieldActions, FieldSelectors>
> {
    return (value, fieldApi) => {
        if (!EMAIL_REGEXP.test(value)) {
            fieldApi.addValidationError({ code });
        }
    };
}
